import { Text, View } from '@react-pdf/renderer';
import { checkObjHasValues } from 'utils';
import parse from 'html-react-parser';

const Certificates = ({ styles, data, headerTitle, randomString }: any) => {
	return (
		<View style={styles.projectsField}>
			<Text style={styles.heading}>{headerTitle}</Text>

			<View style={styles.rightDetails}>
				{data?.map((res: any, index: any) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={res?.title + index}>
								<Text style={styles.detailText}>{res?.title}</Text>
								<Text
									style={styles.detailSubText}
								>{`${res?.description ? parse(res.description) : ''} | ${res?.year}`}</Text>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Certificates;
